/// <reference path="../../../vendor/typings/angularjs/angular.d.ts" />

module Eseebase {
    export class UniversalStorageController implements angular.IController {
        public files: UniversalStoragePagedResult;
        public filters: ModelFilterViewModel;
        public erroLoadingData: boolean;
        public filesToUpload: string[];
        public tagToMany: string;
        public searchKeywords: string[];
        public downloadOngoing: boolean;
        private associations: OrganizationalUnitViewModel[];
        $onInit = () => { };

        constructor(private $scope: any,
            private buildingService: BuildingService,
            private universalStorageService: UniversalStorageService,
            private $q: ng.IQService,
            private $timeout: ng.ITimeoutService,
            private $mdDialog: any,
            private textService: TextService,
            private fileService: FileService,
            private $rootScope: any,
            private organizationService: OrganizationService,
            private organizationSettingsService: OrganizationSettingsService
        ) {
            this.files = new UniversalStoragePagedResult();
            this.tagToMany = '';
            this.searchKeywords = [];
            this.downloadOngoing = false;
            var vm = this;

            $scope.$on('loadUniversalStorage', function (e, pageNumber) {
                if (pageNumber == 1) {
                    vm.files = new UniversalStoragePagedResult();
                }
                vm.loadData();
            });
            $scope.$on('universalstorageLoadMore', () => {
                if (vm.files.scrollId != null) {
                    vm.loadData();
                }
            });
            $scope.imageError = function (sender) {
                if (sender.src != null && sender.src != '' &&
                    vm.fileType(sender.src.match(/(?=[\w\s\-\(\)\[\]\%\+]+(\.)\w{3,4}$).+|(?=[\w\s\-\(\)\[\]\%\+]+(\.)\w{3,4}[\?])[^\?]*/g).toString()) == "image" &&
                    sender.src.indexOf('image/resize') == -1) {
                    sender.src = vm.universalStorageService.getThumbnailUrl(sender.src.replace('-w100.', '.'));
                }
                else {
                    sender.src = "/assets/img/no-image-icon-32.png?x=1";
                }
            }

            $scope.$on('$destroy', function () {
                window.removeEventListener('scroll', this.windowScroll, true);
            });
            window.removeEventListener('scroll', this.windowScroll, true);
            window.addEventListener('scroll', this.windowScroll, true);
            vm.loadOrganizations();
        }

        private windowScroll() {
            var element = document.getElementById('bulkActions');
            if (element == null) {
                return;
            }
            var resultContainer = document.getElementById('resultContainer');
            var box = resultContainer.getBoundingClientRect();
            var body = document.body;
            var scrollTop = window.pageYOffset || element.scrollTop || body.scrollTop;
            var clientTop = element.clientTop || body.clientTop || 0;
            var top = box.top + scrollTop - clientTop;
            if (top == 0) {
                return;
            }

            if (top < 120) {
                element.style.position = 'fixed';
                element.style.top = '4px';
                element.style.width = $('.content-area').css('width');
            }
            else {
                element.style.position = 'relative';
            }
        }

        public loadData() {
            if (this.files.isLastPage || this.files.isLoading) {
                return;
            }
            this.files.isLoading = true;
            var vm = this;
            this.erroLoadingData = false;
            if (this.files.scrollId != null) {
                this.universalStorageService.scroll(this.files.scrollId).then((data: UniversalStoragePagedResult) => {
                    vm.files.isLoading = false;
                    vm.files.totalNumberOfPages = data.totalNumberOfPages;
                    vm.files.totalNumberOfRecords = data.totalNumberOfRecords;
                    if (data.results != null && data.results.length > 0) {
                        vm.files.results = vm.files.results.concat(data.results);
                        if (data.results.length < 10) {
                            vm.files.isLastPage = true;
                        }
                    }
                    else {
                        vm.files.isLastPage = true;
                    }
                }, () => {
                    vm.erroLoadingData = true;
                    vm.files.isLoading = false;
                    vm.files.isLastPage = true;
                    vm.files.scrollId = null;
                    vm.files.results = [];
                });
            }
            else {
                this.filters = this.buildingService.getFilters();
                var filter = new ResultFilterModel();
                if (this.filters.association.any()) {
                    filter.associationIds = this.filters.association.values;
                }
                if (this.filters.department.any()) {
                    filter.departmentIds = this.filters.department.values;
                }
                if (this.filters.localizer.any()) {
                    filter.localizers = this.filters.localizer.values;
                }
                if (this.filters.createdAfter != null) {
                    filter.createdAfter = this.dateToString(this.filters.createdAfter);
                }
                if (this.filters.createdBefore != null) {
                    filter.createdBefore = this.dateToString(this.filters.createdBefore);
                }
                if (this.filters.issueDateAfter != null) {
                    filter.issueDateAfter = this.dateToString(this.filters.issueDateAfter);
                }
                if (this.filters.issueDateBefore != null) {
                    filter.issueDateBefore = this.dateToString(this.filters.issueDateBefore);
                }
                if (this.searchKeywords.length > 0) {
                    filter.keywords = this.searchKeywords;
                }
                this.universalStorageService.getFiles(filter).then((data: UniversalStoragePagedResult) => {
                    vm.files.isLoading = false;
                    vm.files.totalNumberOfPages = data.totalNumberOfPages;
                    vm.files.totalNumberOfRecords = data.totalNumberOfRecords;
                    vm.files.results = vm.files.results.concat(data.results);
                    vm.files.scrollId = data.scrollId;
                    if (data.results.length < 10) {
                        vm.files.isLastPage = true;
                    }

                    vm.$scope.vm.totalResultCount = data.totalNumberOfRecords;
                }, () => {
                    vm.erroLoadingData = true;
                    vm.files.isLoading = false;
                    vm.files.isLastPage = true;
                    vm.files.scrollId = null;
                    vm.files.results = [];
                });
            }
        }

        public dateToString(date: Date) {
            if (date == null) {
                return null;
            }
            var pad = "00";
            return '' + pad.substring(0, pad.length - date.getDate().toString().length) + date.getDate()
                + '-' + pad.substring(0, pad.length - (date.getMonth() + 1).toString().length) + (date.getMonth() + 1).toString()
                + '-' + date.getFullYear() + ' ' + date.getHours() + ':' + date.getMinutes();
        }

        public descriptionChanged(model: UniversalStorageViewModel) {
            model.isEditingDescription = false;
            this.universalStorageService.updateDescription(model.id, model.description);
        }

        public issueDateChanged(model: UniversalStorageViewModel) {
            model.isEditingIssueDate = false;
            if (model.issueDateDp != null) {
                var pad = "00";
                model.issueDate = '' + pad.substring(0, pad.length - model.issueDateDp.getDate().toString().length) + model.issueDateDp.getDate()
                    + '-' + pad.substring(0, pad.length - (model.issueDateDp.getMonth() + 1).toString().length) + (model.issueDateDp.getMonth() + 1).toString()
                    + '-' + model.issueDateDp.getFullYear() + ' 00:00';
            }

            this.universalStorageService.updateIssueDate(model.id, model.issueDate);
        }

        public showDialog(model: UniversalStorageViewModel, $event) {
            $event.stopPropagation();
            var vm = this;
            var dialog = {
                controller: function () {
                    this.model = model;
                    this.$mdDialog = vm.$mdDialog;
                    this.zoomFactor = 1;
                    var self = this;
                    this.zoomIn = function() {
                        if (this.zoomFactor < 2) {
                            this.zoomFactor += 0.25;
                        }
                    }

                    this.zoomOut = function() {
                        if (this.zoomFactor > 0.5) {
                            this.zoomFactor -= 0.25;
                        }
                    }

                    this.encodeUrl = function (url: string) {
                        return encodeURI(url);
                    }

                    this.imageError = function (sender: any) {
                        sender.src = this.model.url.replace(/-md/g, '').replace(/-sm/g, '');
                        sender.srcset = '';
                    }
                },
                controllerAs: 'vm',
                templateUrl: '/app/dialog/image-preview.html',
                parent: angular.element(document.body),
                clickOutsideToClose: true,
                targetEvent: $event
            };
            this.$mdDialog.show(dialog);
        }

        public onTagChanged(model: UniversalStorageViewModel) {
            var tagsWrapper = new TagsWrapperModel();
            tagsWrapper.tags = model.tags;
            this.universalStorageService.updateTags(model.id, tagsWrapper);
        }

        public onSearchChanged() {
            this.files.isLastPage = false;
            this.files.scrollId = null;
            this.files.results = [];
            this.loadData();
        }

        public getFileExtension(fileName: string) {
            return fileName.lastIndexOf(".") != -1 ? fileName.split('.').pop().toLowerCase() : '';
        }

        public fileType(fileName: string) {
            if (fileName == null || fileName == "") {
                return "link";
            }
            var extension = this.getFileExtension(fileName);
            switch (extension) {
                // Bmp file extensions
                case "bmp":
                // Jpeg file extensions
                case "jpeg":
                case "jpg":
                case "jpe":
                case "jfif":
                case "jif":
                case "jfi":
                // Png file extensions
                case "png":
                case "apng":
                // Gif file extensions
                case "gif":
                // Svg file extensions
                case "svg":
                    return "image";
            }
            return extension;
        }

        public getThumbnailUrl(image: DrawingViewModel) {
            if (image == null || image.url == null || image.url == '' || this.fileType(image.fileName) != 'image') {
                return null;
            }
            var newFileName = image.url.replace(/(?=[\w\s\-\(\)\[\]\%\+]+(\.)\w{3,4}$).+|(?=[\w\s\-\(\)\[\]\%\+]+(\.)\w{3,4}[\?])[^\?]*/g, (match, $1) => {
                var x = match.replace('.', '-w100.');
                return x;
            });
            return newFileName;
        }

        public getPreviewUrl(image: DrawingViewModel) {
            if (image.fileName == null || image.fileName == "") {
                return "/assets/img/baseline-link-24px.svg";
            }
            var extension = this.getFileExtension(image.fileName);
            switch (extension) {
                case "tif":
                    return "/assets/img/tiff.svg";
                case "pdf":
                    return "/assets/img/pdf-icon.png";
                case "dwf":
                    return "/assets/img/dwf-icon.png";
                case "zip":
                    return "/assets/img/zip-icon.png";
            }
            return "/assets/img/file-icon.png";
        }

        public showSpinner() {
            var vm = this;
            var dialog = {
                templateUrl: '/app/dialog/spinner.html',
                parent: angular.element(document.body),
                clickOutsideToClose: false
            };
            this.$mdDialog.show(dialog);
            return dialog;
        }

        public onUploadStart(eventArgs: UploadEventArgs) {
            var vm = this;
            this.filesToUpload = eventArgs.fileNames;
            var spinner = this.showSpinner();
            this.universalStorageService.uploadFiles(
                eventArgs.associationId,
                eventArgs.departmentId,
                eventArgs.localizer,
                eventArgs.formData).then((data: UniversalStorageViewModel[]) => {
                    vm.files.totalNumberOfRecords += data.length;
                    vm.files.results = data.concat(vm.files.results);
                    vm.refreshAtachment(eventArgs);
                    vm.$mdDialog.cancel();
                }, () => {
                    vm.refreshAtachment(eventArgs);
                    vm.$mdDialog.cancel();
                });
        }

        public refreshAtachment(eventArgs: UploadEventArgs) {
            if (eventArgs.localizer != null && eventArgs.localizer.constructor.name == "Array") {
                for (var localizer of eventArgs.localizer) {
                    this.fileService.refreshAttachment(eventArgs.associationId, eventArgs.departmentId, localizer);
                }
            }
            else {
                this.fileService.refreshAttachment(eventArgs.associationId, eventArgs.departmentId, eventArgs.localizer);
            }
        }


        public getFileLocality(file: UniversalStorageViewModel) {
            var result = '';
            if (file == null) {
                return ' ';
            }

            if (file.associationId != null && file.associationId != '' && file.associationId != 'null') {
              var association = this.associations.filter(c => c.id == file.associationId);
              if (association != null && association.length > 0) {
                  result += association[0].number;

                  if (file.departmentId != null && file.departmentId != '' && file.departmentId != 'null') {
                    var department = association[0].children.filter(c => c.id == file.departmentId)
                    if (department != null && department.length > 0) {
                        if (result != '') {
                          result += ' - ';
                        }
                        result += department[0].number;
                    }
                  }
              }
            }

            if (file.localizer != null && file.localizer != '' && file.localizer != 'null') {
                if (result != '') {
                    result += ' - ';
                }
                result += file.localizer;
            }
            if (result == '') {
                result = ' ';
            }
            return result;
        }

        private loadOrganizations() {
            var vm = this;
            vm.organizationService.list().then((response: OrganizationalUnitViewModel[]) => {
                vm.associations = response;
            });
        }

        public hideStandardLocality(): boolean {
            if (this.organizationSettingsService.uiStyling != null) {
                return this.organizationSettingsService.uiStyling.universalStorageHideStandardLocality();
            }
            return false;
        }

        public showDetailedLocality(): boolean {
            if (this.organizationSettingsService.uiStyling != null) {
                return this.organizationSettingsService.uiStyling.universalStorageShowDetailedLocality();
            }
            return false;
        }

        public getFileAssociationName(file: UniversalStorageViewModel) {
            var vm = this;
            if (file == null) {
                return ' ';
            }
            if (file.associationId != null && file.associationId != '' && file.associationId != 'null') {
                var associationName;
                var association = this.associations.filter(c => c.id == file.associationId);
                if (association != null && association.length > 0) {
                    associationName = association[0].name;
                }
                if (associationName != null && associationName != '') {
                    return associationName;
                }
            }
            return ' ';
        }

        public getFileDepartmentName(file: UniversalStorageViewModel) {
            var vm = this;
            if (file == null) {
                return ' ';
            }
            if (file.associationId != null && file.associationId != '' && file.associationId != 'null') {
                if (file.departmentId != null && file.departmentId != '' && file.departmentId != 'null') {
                    var departmentName;
                    var association = this.associations.filter(c => c.id == file.associationId);
                    if (association != null && association.length > 0) {
                        var department = association[0].children.filter(c => c.id == file.departmentId);
                        if (department != null && department.length > 0) {
                            departmentName = department[0].name;
                        }
                    }
                    if (departmentName != null && departmentName != '') {
                        return departmentName;
                    }
                }
            }
            return ' ';
        }

        public getFilePrimaryLocalizer(file: UniversalStorageViewModel) {
            if (file == null) {
                return ' ';
            }
            if (file.localizers != null && file.localizers.length > 0 && file.localizers[0] != '' && file.localizers[0] != 'null') {
                return file.localizers[0];
            }
            return ' ';
        }

        public getFileAdditionalLocalizers(file: UniversalStorageViewModel) {
            var result = [];
            if (file == null) {
                return ' ';
            }
            if (file.localizers != null && file.localizers.length > 1) {
                for (var i = 1; i < file.localizers.length; i++) {
                    if (file.localizers[i] != '' && file.localizers[i] != 'null') {
                        result.push(file.localizers[i]);
                    }
                }
                return result.length > 0 ? result : ' ';
            }
            return ' ';
        }

        public toggleSelection(file: UniversalStorageViewModel) {
            if (file != null) {
                if (file.active == null) {
                    file.active = false;
                }
                file.active = !file.active;
                var vm = this;
                this.$timeout(() => {
                    vm.windowScroll();
                });
            }
        }

        public editDescription(file: UniversalStorageViewModel, $event) {
            $event.stopPropagation();
            if (file != null) {
                if (file.isEditingDescription == null) {
                    file.isEditingDescription = false;
                }
                file.isEditingDescription = !file.isEditingDescription;
            }
            var $card = angular.element($event.target).closest('md-card-title-text');
            this.$timeout(() => {
                $card.filter('.edit-description').focus();
            }, 500);

            var cardId = angular.element($event.target).closest('md-card-title-text').attr('id');

            var vm = this;
            var onFieldBlur = function (e) {
                angular.element('#' + cardId + ' .edit-description')[0].removeEventListener('blur', onFieldBlur, true);
                vm.$timeout(() => {
                    file.isEditingIssueDate = false;
                });
            }

            this.$timeout(() => {
                var f$ = angular.element('#' + cardId + ' .edit-description');
                f$.focus();
                f$[0].addEventListener('blur', onFieldBlur, true);
            }, 500);
        }

        public editIssueDate(file: UniversalStorageViewModel, $event) {
            $event.stopPropagation();
            if (file != null) {
                if (file.isEditingIssueDate == null) {
                    file.isEditingIssueDate = false;
                }
                file.isEditingIssueDate = !file.isEditingIssueDate;
                if (file.issueDate != null) {
                    var dateSplit = file.issueDate.split(' ');
                    var dateParts = dateSplit[0].split('-');
                    file.issueDateDp = new Date(parseInt(dateParts[2]), parseInt(dateParts[1]) - 1, parseInt(dateParts[0]));
                }
            }
        }

        public deleteSelected($event) {
            if (this.files != null && this.files.results != null) {
                var vm = this;
                var confirm = this.$mdDialog.confirm()
                    .title(vm.textService.translate('UniversalStorage_Delete'))
                    .textContent(vm.textService.translate('UniversalStorage_DeleteConfirm'))
                    .ariaLabel(vm.textService.translate('UniversalStorage_Delete'))
                    .targetEvent($event)
                    .ok(vm.textService.translate('Button_OK'))
                    .cancel(vm.textService.translate('Button_Cancel'));

                this.$mdDialog.show(confirm).then(() => {
                    var promises = [];
                    var idsToDelete = [];
                    var objToDelete: UniversalStorageViewModel[] = [];
                    for (var f of vm.files.results) {
                        if (f.active) {
                            promises.push(vm.universalStorageService.delete(f.id));
                            idsToDelete.push(f.id);
                            for (var l of f.localizers) {
                                if (!objToDelete.some((v) => v.associationId == f.associationId && v.departmentId == f.departmentId && v.localizer == l)) {
                                    var o = new UniversalStorageViewModel();
                                    o.associationId = f.associationId;
                                    o.departmentId = f.departmentId;
                                    o.localizer = l;
                                    objToDelete.push(o);
                                }
                            }
                        }
                    }

                    this.$q.all(promises).then(() => vm.$timeout(() => {
                        vm.files.results = vm.files.results.filter(ff => idsToDelete.indexOf(ff.id) == -1);
                        if (vm.files.results.length == 0) {
                            vm.files.totalNumberOfRecords = 0;
                            vm.files.totalNumberOfPages = 0;
                        }
                        else {
                            vm.files.totalNumberOfRecords -= idsToDelete.length;
                        }
                        for (var f of objToDelete) {
                            vm.fileService.refreshAttachment(f.associationId, f.departmentId, f.localizer);
                        }
                    }),
                        () => { });
                }, () => { });

            }
        }

        public downloadSelected() {
            var vm = this;
            vm.downloadOngoing = true;
            var fileIds:string[] = [];
            for (var f of vm.files.results) {
                if (f.active) {
                    fileIds.push(f.id)
                }
            }
            vm.universalStorageService.downloadFiles(fileIds).then((data) => {
                var name = 'Download.zip';
                if (data != null && navigator.msSaveBlob)
                    return navigator.msSaveBlob(data, name);
                var a = $("<a style='display: none;' target='_blank'/>");
                var url = URL.createObjectURL(new Blob([data], { 'type': "application/octet-stream" }));
                a.attr("href", url);
                a.attr("download", name);
                $("body").append(a);
                a[0].click();
                window.URL.revokeObjectURL(url);
                a.remove();
                vm.downloadOngoing = false;
            }, () => {
                vm.downloadOngoing = false;
            });
        }

        public getSelectedFiles() {
            if (this.files != null && this.files.results != null) {
                return this.files.results.filter(f => f.active);
            }
            else {
                return [];
            }
        }

        public anyFileSelected() {
            if (this.files != null && this.files.results != null) {
                return this.files.results.some(f => f.active);
            }
            return false;
        }

        public selectedCount() {
            return this.getSelectedFiles().length;
        }

        public clearSelection() {
            if (this.files != null && this.files.results != null) {
                for (var f of this.files.results) {
                    f.active = false;
                }
            }
        }

        public addTagToMany() {
            if (this.files != null && this.files.results != null && this.tagToMany != null && this.tagToMany != '') {
                for (var f of this.files.results) {
                    if (f.active && f.tags.indexOf(this.tagToMany) == -1) {
                        f.tags.push(this.tagToMany);
                        this.onTagChanged(f);
                    }
                }
            }
            this.tagToMany = '';
        }

        public isLocalUrl(file: UniversalStorageViewModel) {
            if (file != null && file.url != null) {
                return file.url.indexOf('universalstorage') > -1;
            }
            return false;
        }

        public formatDate(timestamp: string, withTime: boolean) {
            if (timestamp == null) {
                return null;
            }
            var dateTimeParts = timestamp.split(' ');
            if (dateTimeParts.length == 2) {
                var dateParts = dateTimeParts[0].split('-');
                if (dateParts.length == 3) {
                    var today = new Date();
                    if (parseInt(dateParts[0]) == today.getDate() && (parseInt(dateParts[1]) == today.getMonth() + 1) && parseInt(dateParts[2]) == today.getFullYear()) {
                        return this.textService.translate('Today') + (withTime ? ' ' + dateTimeParts[1] : '');
                    }
                    else if ((parseInt(dateParts[0]) == today.getDate() - 1) && parseInt(dateParts[1]) == today.getMonth() + 1 && parseInt(dateParts[2]) == today.getFullYear()) {
                        return this.textService.translate('Yesterday') + (withTime ? ' ' + dateTimeParts[1] : '');
                    }
                }
                return dateTimeParts[0] + (withTime ? ' ' + dateTimeParts[1] : '');
            }
            return timestamp;
        }

        public clearTags($event) {
            var confirm = this.$mdDialog.confirm()
                .title(this.textService.translate('UniversalStorage_ClearTags'))
                .textContent(this.textService.translate('UniversalStorage_ClearTagsConfirm'))
                .ariaLabel(this.textService.translate('UniversalStorage_ClearTags'))
                .targetEvent($event)
                .ok(this.textService.translate('Button_OK'))
                .cancel(this.textService.translate('Button_Cancel'));

            var vm = this;
            this.$mdDialog.show(confirm).then(() => {
                if (vm.files != null && vm.files.results != null) {
                    for (var f of vm.files.results) {
                        if (f.active && f.tags.length > 0) {
                            f.tags = [];
                            vm.onTagChanged(f);
                        }
                    }
                }
            });
        }

        public getMailtoLink() {
            if (this.files != null && this.files.results != null) {
                var body = '';
                for (var file of this.files.results) {
                    if (file.active) {
                        body += file.url.replace(/\s/g, '%20') + '\n';
                    }
                }
                var bodyTemplate = this.textService.translate('UniversalStorage_SendLinkMailBody');
                return 'mailto:someone@eseebase.dk?subject=' + encodeURIComponent(this.textService.translate('UniversalStorage_SendLinkMailSubject')) + '&body=' + encodeURIComponent(bodyTemplate.replace(/\\n/g, '\n').replace('{0}', body));
            }
            return '';
        }

        public searchTagTextChange(searchText: string) {
            return this.universalStorageService.searchTags(searchText);
        }
    }

    UniversalStorageController.$inject = ['$scope', 'BuildingService', 'UniversalStorageService', '$q', '$timeout', '$mdDialog', 'TextService', 'FileService', '$rootScope', 'OrganizationService', 'OrganizationSettingsService'];

    angular
        .module('eseebase')
        .controller('UniversalStorageController', UniversalStorageController);
}